<template>
  <div class="head" :class="isSearch && 'isSearch'">
    <img
      src="../../assets/img/meau.png"
      @click="wapShowMeau"
      class="wapmeau"
      style="cursor: pointer"
    />
    <img
      class="logo"
      src="https://master-shopvidi.s3.amazonaws.com/index_images/shop_logo%402x.png"
      @click="$router.push('/')"
    />
    <img
      class="search-icon search-icon-visitor"
      src="../../assets/search-icon.png"
      :style="login ? 'right:120px' : 'right:130px'"
      ref="searchBtn"
      width="20px"
      height="20px"
      @click="$router.push('/search')"
    />
    <div class="search-box" ref="searchBox">
      <el-input
        v-model="valueData.value"
        prefix-icon="el-icon-search"
        @blur="blurHandle"
        @focus="focusHandle"
        @input="queryBrand"
        placeholder="Search Product Name/Collections/Category/Brands/Sku"
        clearable
      ></el-input>
      <el-button
        type="primary"
        class="search-btn"
        @click="onSubmit"
        @keyup.enter.native="enterSearch()"
        >Search</el-button
      >
      <el-checkbox v-if="isShow1V1Checkbox" v-model="checked1v1" @change="change1v1">是否显示1v1视频</el-checkbox>
    </div>

    <div class="brand-main" v-if="brandList.length > 0">
      <div class="brands-title">Brands</div>
      <!-- 内部的品牌信息 -->
      <div v-for="(item,index) in brandList" :key="index" class="brand-row" @click="gotoBrand(item)" :ref="'select-'+index" @mousemove="changeColor($event)" @mouseleave="resetColor($event)">
        <img :src="item.brandLogoUrl" style="height:50px;width:50px;border: 1px solid #E1E1E1;border-radius:50%;"/>
        <!-- <div class="brands-img">
          <img :src="item.brandLogoUrl" style="height:35px;width:35px"/>
        </div> -->
        <div class="brand-name">{{item.brandName}}</div>
<!--        <div style="position: absolute;left: 200px">-->
          <div v-if="item.isVilocal" class="brand-vilocal">ViLocal</div>
          <el-tag v-if="item.salesManager" style="margin-left: 10px;" type="danger">Top Brand</el-tag>
<!--        </div>-->
      </div>
    </div>
    <div class="login-btns" v-if="login" >
      <div class="content1-right-personimg-user hide shopping-cart" @click="gotoShoppingCart">

        <div  class="shopping-cart-info hide">{{ shoppingCartValue == 0 ? '0 Item':shoppingCartValue + ' Items' }}</div>
        <div  class="shopping-cart-info-mobile">{{ shoppingCartValue==0? 0:shoppingCartValue }}</div>
        <el-badge :is-dot="!shoppingCartValue==0" class="item">
          <div  class="cart">
            <img height="25px" width="25px" src="../../assets/shopping-icon.png"/>
          </div>
        </el-badge>
      </div>
      <div class="content1-right-personimg-user hide my-icon "    @mouseover="showMenu" @mouseleave="hideMenu">
        <img class="my-img" height="25px" width="25px" src="../../assets/my.png"/>
      </div>
      <div class="content1-right-personimg-user  content1-right-coupon" @click="$router.push({path:'/coupon'})">
        <div class="count_num" v-if="myCouponCount">{{myCouponCount}}</div>
        <img height="25px" width="25px" src="../../assets/shopping-coupon.png" />
      </div>
      <div class=" search-icon content1-right-personimg-user">
        <img
      src="../../assets/search-icon.png"
      :style="login ? 'right:120px' : 'right:130px'"
      width="20px"
      height="20px"
      @click="$router.push('/search')"
    />
      </div>

    </div>
    <div class="login-btns visitor" v-else>
      <!-- <div class="content1-right-personimg content_vidirect" @click="toVidirectHandel()">
        <p class="to_vidirect">Sell on ShopVidi</p></div> -->
      <div class="content1-right-personimg hide my">
        <img height="17px" width="17px" src="../../assets/img/use.png" />
      </div>

      <div class="right-content-reg" @click="loginHandle('register')">
        <span class="content1-btn" style="color: #ffffff">Sign up</span>
      </div>
      <div class="right-content-reg show" @click="loginHandle('register')">
        <span class="content1-btn" style="color: #ffffff">Sign up</span>
      </div>
      <div class="right-content-reg" @click="showTempLogin" v-if="isPre">
        <span class="content1-btn" style="color: #ffffff">模拟登录</span>
      </div>
      <div class="right-content-reg" @click="showSdrLogin" v-if="isPre">
        <span class="content1-btn" style="color: #ffffff">SDR/SR</span>
      </div>
      <div class="right-content-login" @click="loginHandle('login')">
        <span class="content1-btn">Login</span>
      </div>
    </div>

    <!-- PC端我的 -->
    <div
      class="meau"
      :style="showMeau ? 'height:auto' : 'height:0'"
      @mouseover="showMenu"
      @mouseleave="hideMenu">
      <div class="meau-body">
        <div class="meau-top">
          <div style="text-align: center">Hello,{{ realname }}</div>
        </div>
        <!-- <template v-if="(isFirstOrder&&isShowNt)||!isFirstOrder"> -->
        <!-- 1.7.1 NT支付优化 -->
        <template v-if="isUseNt">
        <!-- 申请成功有值 -->
          <template
            v-if="(pcPayMenthod.pcNetQualificationStatus=='completed'||pcPayMenthod.pcNetQualificationStatus=='approved')">
            <div class="apply-border">
              <div class="info">
                <!-- add by cpgu 2022/10/26 begin -->
                <div class="net-term" v-if="!netPayable">
                  <p @click="$router.push({name: 'profile'})">Open net term payment</p>
                  <p style="font-size: 12px;">{{ tooltipText.split(",")[0] }}</p>
                </div>
                <!-- end by cpgu -->

                <template v-else>
                  <div class="info-name">
                    <span>Net terms</span>
                    <span class="status color-green">Active</span>
                  </div>
                  <div class="money_box">
                    <div>
                      <div class="money" v-if="pcPayMenthod.creditLimit">
                        <div>${{ pcPayMenthod.totalCreditLimit | numFormat }}</div>
                        <!-- 没有品牌优惠额度，提额入口 -->
                        <template v-if="!pcPayMenthod.exclusiveAvailableLimit">
                          <div class="shoping_button" v-if="increaseStatus" @click="$router.push({name:'apply'})">
                            Increase My Limit
                          </div>
                          <div class="shoping_button" v-else>Review increase limit</div>
                        </template>
                      </div>
                      <div class="info-desc" v-if="pcPayMenthod.creditLimit">Credits available</div>
                    </div>
                    <div class="line_between" v-if="pcPayMenthod.exclusiveAvailableLimit"></div>
                    <div class="money_box_right" v-if="pcPayMenthod.exclusiveAvailableLimit">
                      <div class="money">
                        <div>${{ pcPayMenthod.exclusiveAvailableLimit }}</div>
                      </div>
                      <div class="info-desc">{{ pcPayMenthod.exclusiveBrandName }} Credits</div>
                    </div>
                  </div>

                  <!-- 如果存在品牌优惠额度和net额度，则提额入口，单独一行显示 add by cpgu 20220914-->
                  <template v-if="pcPayMenthod.exclusiveAvailableLimit">
                    <div style="margin-top: 15px;margin-left: 0px;" v-if="increaseStatus" class="shoping_button"
                         @click="$router.push({name:'apply'})">Increase My Limit
                    </div>
                    <div style="margin-top: 15px;margin-left: 0px;" v-else class="shoping_button">Review increase
                      limit
                    </div>
                  </template>
                  <!-- end by cpgu 2022/09/14 -->
                </template>

              </div>
            </div>
          </template>
          <template
            v-if="pcPayMenthod.pcNetQualificationStatus === 'inReview' || pcPayMenthod.pcNetQualificationStatus === 'frozen'">
            <div class="apply-border">
              <div class="info">
                <!-- add by cpgu 2022/09/14 begin -->
                <div class="net-term" v-if="!netPayable">
                  <p @click="$router.push({name: 'profile'})">Open net term payment</p>
                  <p style="font-size: 12px;">{{ tooltipText.split(",")[0] }}</p>
                </div>
                <!-- end by cpgu -->
                <template v-else>
                  <div class="info-name">
                    <span>Net terms</span>
                    <span v-if="pcPayMenthod.pcNetQualificationStatus !== 'inReview'"
                          :class="pcPayMenthod.pcNetQualificationStatus === 'inReview'?'status color-gray':'status color-blue'">{{
                        pcPayMenthod.pcNetQualificationStatus | toFirstUpper
                      }}</span>
                  </div>
                  <!-- 冻结(添加以下if) add by cpgu 2022/09/15 -->
                  <div class="net-term" v-if="pcPayMenthod.pcNetQualificationStatus === 'frozen'">
                    <p style="cursor: none;text-decoration: none;">Contact Customer Service</p>
                    <p style="font-size: 12px;">To unlock the net term status</p>
                  </div>
                  <div v-else class="money_box">
                    <div>
                      <div class="money">
                        <div>${{ pcPayMenthod.totalCreditLimit | numFormat }}</div>
                        <!-- 没有品牌优惠额度，提额入口 -->
                        <template v-if="!pcPayMenthod.exclusiveAvailableLimit">
                          <div class="shoping_button" v-if="increaseStatus" @click="$router.push({name:'apply'})">
                            Increase
                            My Limit
                          </div>
                          <div class="shoping_button" v-else>Review increase limit</div>
                        </template>
                        <!-- <div class="shoping_button" v-if="pcPayMenthod.pcNetQualificationStatus === 'frozen'" @click="unfreezeHandel()">unfreeze</div> -->
                      </div>
                      <div class="info-desc">Credits available</div>
                    </div>
                    <div class="line_between" v-if="pcPayMenthod.exclusiveAvailableLimit "></div>
                    <div class="money_box_right" v-if="pcPayMenthod.exclusiveAvailableLimit ">
                      <div class="money">
                        <div>${{ pcPayMenthod.exclusiveAvailableLimit }}</div>
                      </div>
                      <div class="info-desc">{{ pcPayMenthod.exclusiveBrandName }} Credits</div>
                    </div>
                  </div>

                  <!-- 如果存在品牌优惠额度和net额度，则提额入口，单独一行显示 add by cpgu 20220914-->
                  <template v-if="pcPayMenthod.exclusiveAvailableLimit">
                    <div style="margin-top: 15px;margin-left: 0px;" v-if="increaseStatus" class="shoping_button"
                         @click="$router.push({name:'apply'})">Increase My Limit
                    </div>
                    <div style="margin-top: 15px;margin-left: 0px;" v-else class="shoping_button">Review increase limit
                    </div>
                  </template>
                  <!-- end by cpgu 2022/09/14 -->

                </template>

              </div>
            </div>
          </template>
          <template
            v-if="pcPayMenthod.pcNetQualificationStatus=='declined' || pcPayMenthod.pcNetQualificationStatus=='disabled'">
            <div class="apply-border">
              <div class="info">
                <!-- add by cpgu 2022/09/14 begin -->
                <div class="net-term" v-if="!netPayable">
                  <p @click="$router.push({name: 'profile'})">Open net term payment</p>
                  <p style="font-size: 12px;">{{ tooltipText.split(",")[0] }}</p>
                </div>
                <!-- end by cpgu -->

                <div class="info-name" v-if="netPayable">
                  <span>Net terms</span>
                  <span
                    :class="pcPayMenthod.pcNetQualificationStatus=='declined'?'status color-red':'status color-brown'">{{ pcPayMenthod.pcNetQualificationStatus | toFirstUpper }}</span>
                </div>
                <!-- add by cpgu 2022/09/15 begin -->
                <div class="net-term" v-if="netPayable">
                  <p style="cursor: none;text-decoration: none;">Contact Customer Service</p>
                  <p style="font-size: 12px;">To unlock the net term status</p>
                </div>
                <!-- end by cpgu -->

              </div>
              <!-- <div class="type" @click="addItems">Apply for Terms</div> -->
            </div>
          </template>
          <template v-if="!pcPayMenthod.pcNetQualificationStatus">
            <div class="apply-border">
              <div class="info">
                <div class="info-name" v-if="netPayable">
                  <span>Net terms</span>
                  <!--                <span class="status color-orange">Inactivated</span>-->

                  <el-tooltip class="item" effect="dark" :content="tooltipText" placement="top">
                    <i class="el-icon-warning-outline" style="font-size:20px"></i>
                  </el-tooltip>

                  <!-- <span class="status color-grey">In Review</span>
                  <span class="status color-green">Active</span>
                  <span class="status color-red">Declined</span>
                  <span class="status color-blue">Frozen</span>
                  <span class="status color-brown">Dsabled</span> -->
                </div>
                <!-- add by cpgu 2022/09/14 begin -->
                <div class="net-term" v-if="!netPayable">
                  <p @click="$router.push({name: 'profile'})">Open net term payment</p>
                  <p style="font-size: 12px;">{{ tooltipText.split(",")[0] }}</p>
                </div>
                <!-- end by cpgu -->

                <!-- <div class="shoping_button" @click="shopingHandel()">Go Shopping</div> -->
                <div class="money_box" v-if="netPayable">
                  <div>
                    <div class="money">
                      <div>${{ pcPayMenthod.totalCreditLimit | numFormat }}</div>
                      <!-- 没有品牌优惠额度，提额入口 add by cpgu -->
                      <template v-if="!pcPayMenthod.exclusiveAvailableLimit">
                        <div class="shoping_button" v-if="increaseStatus" @click="$router.push({name:'apply'})">Increase
                          My Limit
                        </div>
                        <div class="shoping_button" v-else>Review increase limit</div>
                      </template>
                    </div>
                    <div class="info-desc">Credits available</div>
                  </div>
                  <div class="line_between" v-if="pcPayMenthod.exclusiveAvailableLimit"></div>
                  <div class="money_box_right" v-if="pcPayMenthod.exclusiveAvailableLimit">
                    <div class="money">
                      <div>${{ pcPayMenthod.exclusiveAvailableLimit }}</div>
                    </div>
                    <div class="info-desc">{{ pcPayMenthod.exclusiveBrandName }} Credits</div>
                  </div>
                </div>
                <!-- add by cpgu 2022/09/14 如果存在品牌优惠额度和net额度，则提额入口，单独一行显示 begin-->
                <template v-if="pcPayMenthod.exclusiveAvailableLimit && netPayable">
                  <div style="margin-top: 15px;margin-left: 0px;" v-if="increaseStatus" class="shoping_button"
                       @click="$router.push({name:'apply'})">Increase My Limit
                  </div>
                  <div style="margin-top: 15px;margin-left: 0px;" v-else class="shoping_button">Review increase limit
                  </div>
                </template>
                <!--- end by cpgu -->

              </div>
              <!-- <div class="type" @click="addItems">Apply for Terms</div> -->
            </div>
          </template>
        </template>
        <!-- <template v-if="(limit.qualificationStatus=='completed'||limit.qualificationStatus=='approved')">
          <div class="apply-border" >
            <div class="info" >
              <div class="info-name">
                <span>Net terms</span>
                <span class="status color-green">Active</span>
              </div>
               申请成功之后的话，是否显示额度，是看 额度是否有值，如果没有 说明是banks申请的
              <div class="money" v-if="limit.creditLimit">${{limit.creditLimit | numFormat}}</div>
              <div class="info-desc" v-if="limit.creditLimit">Credits available</div>
            </div>
          </div>
        </template> -->
        <!-- pending -->
        <!-- <template v-if="(limit.qualificationStatus=='pending'||limit.qualificationStatus=='' || isError)">
          <div class="apply-border">
            <div class="info">
              <div class="info-name">
                <span>Net terms</span>
              </div>
              <div class="money">${{limit.creditLimit | numFormat}}</div>
              <div class="info-desc">Credits available</div>
            </div>
            <div class="type" @click="addItems">Apply for Terms</div>
          </div>
        </template> -->
        <!-- decline -->
        <!-- <template v-if="limit.qualificationStatus=='declined'">
          <div class="apply-border">
            <div class="info">
              <div class="info-name">
                <span>Net terms</span>
                <span class="status color-red">{{limit.qualificationStatus}}</span>
              </div>
              <div class="money">${{limit.creditLimit | numFormat}}</div>
              <div class="info-desc">Credits available</div>
            </div>
            <div class="type" @click="addItems">Apply for Terms</div>
          </div>
        </template> -->
        <!-- in Review -->
        <!-- <template v-if="limit.qualificationStatus=='inReview'">
          <div class="apply-border">
            <div class="info">
              <div class="info-name">
                <span>Net terms</span>
                <span class="status color-gray">{{limit.qualificationStatus}}</span>
              </div>
              <div class="money">${{limit.creditLimit | numFormat}}</div>
              <div class="info-desc">Credits available</div>
            </div>
          </div>
        </template> -->
        <div class="meau-list">
          <p
            v-for="(item, id) in menuList"
            :key="id"
            v-if="!item.hidden"
            @click="gotoPlatform(item)"
          >
            {{ item.name }}
          </p>
        </div>
        <div class="meau-down" @click="signOut">Sign Out</div>
      </div>
    </div>
    <el-dialog
      :visible.sync="loginVisible"
      :destroy-on-close="true"
      :fullscreen="showH5App?true:false"
      width="880px"
      :append-to-body="true"
      :close-on-click-modal="false"
      class="wap"
      :before-close="handleClose"
       :lock-scroll="true"
    >
      <Login
        @submitHandle="submitHandle"
        :type="loginType"
        :key="loginType"
      ></Login>
    </el-dialog>
    <el-dialog
      :visible.sync="showTempLoginDialog"
      :destroy-on-close="true"
      width="880px"
      :append-to-body="true"
      class="wap"
    >
      <div style="width:90%;padding:20px">
        <el-input v-model="email" placeholder="email" auto-complete="new-password" style="margin:30px 0px"></el-input>
        <el-input v-model="password" placeholder="password" auto-complete="new-password" :type="passw" style="margin-bottom:20px;">
          <i slot="suffix" @click="showPass">
            <img
              v-if="passw=='password'"
              style="width:25px;height:25px"
              src="../../assets/img/icon-hide.png"
              alt="" />
            <img
              v-else
              style="width:25px;height:25px"
              src="../../assets/img/icon-show.png"
              alt="" />
          </i>
        </el-input>
        <el-button @click="tempLogin">Login</el-button>
      </div>
    </el-dialog>
    <SdrLogin :showSdrLoginDialog="showSdrLoginDialog" @sdrLogin="sdrLogin" @closeSdrLoginDialog="closeSdrLoginDialog"></SdrLogin>
  </div>
</template>

<script>
import {loadSysRole} from './loadSysRole.js'
import Vue from 'vue'
import Login from './login.vue'
import { getAction, Logout, getCreditLimit, postAction, putAction } from '@/api/manage.js'
import {buryingPoint} from '../../utils/log'
import {closeWebsocket} from '../../utils/ws'
import SdrLogin from './sdr-login.vue'
export default {
  name: 'Head',
  components: { Login, SdrLogin },
  props: ['getList', 'wapShow', 'isFirstOrder', 'isShowNt'],
  data() {
    return {
      tooltipText: '',
      vidirectUrl: process.env.VIDIRECT_API_URL,
      baseUrl: '',
      showTempLoginDialog: false,
      email: '', // 模拟登录
      password: '', // 模拟登录
      passw: 'password',
      myCouponCount: '',
      menuList: [], // 新的菜单
      isSearch: this.$route.name === 'search',
      realname: '',
      feNetWork: '',
      feCartWork: '',
      showMeau: false,
      loginVisible: false,
      loginType: 'login',
      activeNames: ['1'],
      shoppingCartValue: '', // 购物车的数量
      timer: '',
      meauList: [],
      isError: false,
      focus: false,
      limit: {},
      valueData: {
        value: ''
      },
      pcPayMenthod: {}, // haoyuanw add net  term
      brandList: [],
      netPayable: false, // net可支付状态 true可支付
      increaseStatus: false, // 可提额状态 true可
      isUseNt: false,
      showMenuTimer: null, // 要求实现的鼠标悬浮“我的”图标上方时菜单显示，但是会产生频繁闪烁等现象，考虑加一个防抖来优化体验
      isShow1V1Checkbox: false,
      checked1v1: false,
      showSdrLoginDialog: false // 是否显示SDR/SR登录弹框
    }
  },
  filters: {
    // 保留几位小数
    toFixed(val, len) {
      return val && val !== 0 ? Number(val).toFixed(len) : '-'
    },
    // 数值过千加逗号，并保留几位小数
    numFormat(num, len = 2) {
      var c = num && num !== 0 ? Number(num).toFixed(len).replace(/(\d)(?=(\d{3})+\.)/g, '$1,') : '0.00'
      return c
    },
    toFirstUpper: (value) => {
      return value.slice(0, 1).toUpperCase() + value.slice(1)
    }
  },
  computed: {
    showH5App() {
      return navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
    }
  },
  created() {
    // 判断页面是否有邮箱才能显示
    this.isShow1V1()
    this.getCheck1v1()
    this.enterSearch()
    this.baseUrl = window.location.origin
    if (location.pathname.indexOf('brand') != -1) {
      this.valueData.value = ''
    }
    this.feNetWork = this.getEnvUrl()
    this.feCartWork = this.getEnvUrl('feCartWork')
    this.realname = this.$ls.get('realname') || ''

    if (this.login) {
      this.loadMenu()
      //  haoyuanw add 2022-01-25 增加查询 当前用户是否有后台编辑权限
      this.loadSysRole()
      // 查询用户是否具备500额度
      this.isAllowNt()
      // 提额状态
      this.loadIncreaseStatus()
      this.checkIsUseNt()
      this.$nextTick(() => {
        let searchBtn = this.$refs.searchBtn
        if (searchBtn) {
          searchBtn.style.display = 'none'
        }
        let searchBox = this.$refs.searchBox
        if (searchBox) {
          searchBox.style['margin-right'] = '-130px'
        }
      })
    }
    console.log(this.login, '是否登录')
    if (this.login && this.$ls.get('token') !== undefined) {
      this.getPcNetTerm()
      // this.getCreditLimit()
    }

    if (this.login && this.$ls.get('token') !== undefined) {
      // 定时请求获取购物车数量
      this.timer = setInterval(this.getShoppingCartValue, 3000)
      this.timer = setInterval(this.getCouponCount, 3000)
    }

    if (localStorage.getItem('show') == 1) {
      this.loginVisible = true
      localStorage.setItem('show', 2)
    }
    if (location.hash.split('?')[0] == '/brand') {
    }
    let timer = setInterval(this.loginEdit(), 2000)
    if (localStorage.getItem('userlogin') == 401 && this.loginVisible) {
      clearInterval(timer)
      localStorage.removeItem('userlogin')
    }
  },
  mounted() {

  },
  /**
   * 关闭该页面的时候进行销毁
   */
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    // 2.2.15 haoyuanw add SDR/SR 模拟登录弹框
    showSdrLogin() {
      this.showSdrLoginDialog = true
    },
    closeSdrLoginDialog() {
      this.showSdrLoginDialog = false
    },
    async sdrLogin(sdrLoginForm) {
      // TODO 调用后端接口进行登录  参照tempLogin()
      let res = await postAction('/sys/sdr-login', sdrLoginForm)
      if (res.code === 200) {
        this.$ls.set('token', res.result.token)
        this.$ls.set('userInfo', res.result.userInfo)
        this.$ls.set('realname', res.result.userInfo.realname)
        Vue.prototype.login = true
        this.closeSdrLoginDialog()
        this.submitHandle()
      } else {
        this.$message.warning(res.message)
      }
    },
    getCheck1v1() {
      getAction('/simple/configuration?key=check1v1').then(response => {
        if (response.success) {
          if (response.result) {
            if (response.result.configurationValue === 'true') {
              this.checked1v1 = true
            } else {
              this.checked1v1 = false
            }
          }
        } else {
          this.$message.warning(response.message)
        }
      })
    },
    change1v1(value) {
      // 切换调用接口
      putAction('/simple/configuration/key?key=check1v1&value=' + value).then(response => {})
    },
    // 必须是预发环境，并且邮箱参数必须是 公司的测试邮箱才会显示
    isShow1V1() {
      let email = this.$route.query.email
      if (email && email === 'test@shopvidi.com' && window.location.origin === 'https://staging.shopvidi.com') {
        this.isShow1V1Checkbox = true
      }
    },
    checkIsUseNt() {
      if (this.login) {
        getAction('/sys/user/queryById?id=' + JSON.parse(localStorage.getItem('pro__userInfo')).value.id).then(response => {
          if (response.success) {
            this.isUseNt = response.result.isUseNt
          } else {
            this.$message.warning(response.message)
          }
        })
      }
    },
    showPass() {
      // 点击图标是密码隐藏或显示
      if (this.passw == 'text') {
        this.passw = 'password'
      } else {
        this.passw = 'text'
      }
    },
    loadIncreaseStatus() {
      getAction('/v0.2/register/increase-status').then((response) => {
        if (response.success) {
          this.increaseStatus = response.result
        }
      })
    },

    isAllowNt() {
      getAction('/register/check-nt').then((response) => {
        if (response.success) {
          if (response.result) {
            this.netPayable = true
            // this.tooltipText = 'Apply to increase net term limit to pay for more orders'
            this.tooltipText = 'Buy more,Repay more timely,Get more Credits'
          } else {
            this.netPayable = false
            this.tooltipText = 'Currently only supports bricks and mortar store business owners in the US , and will be opened to more countries soon'
          }
        }
      })
    },
    // 跳转到供应商平台
    toVidirectHandel() {
      //  window.open(this.vidirectUrl)
      window.open('https://brand.shopvidi.com')
    },
    showTempLogin() {
      this.showTempLoginDialog = true
    },
    async tempLogin() {
      let res = await postAction('/sys/temp-login?username=' + this.email + '&password=' + this.password)
      if (res.code === 200) {
        this.$ls.set('token', res.result.token)
        this.$ls.set('userInfo', res.result.userInfo)
        this.$ls.set('realname', res.result.userInfo.realname)
        Vue.prototype.login = true
        this.submitHandle()
      } else {
        this.$message.warning(res.message)
      }
    },
    shopingHandel() {
      getAction('/recommended/go-shopping').then((response) => {
        if (response.success) {
          this.$router.push({name: 'category', params: {'firstName': (response.result[0].firstName).replaceAll(' ', '_'), 'secondName': (response.result[1].secondName).replaceAll(' ', '_')}})
        } else {
          if (response.message == 'No Recommended Category') {
            this.$router.push('/')
          } else {
            this.$message.warning(response.message)
          }
        }
      })
    },
    unfreezeHandel() {
      this.$message.warning('Please contact our staff to apply to lift the freeze!')
    },
    loginEdit() {
      if (localStorage.getItem('userlogin') == 401) {
        this.loginVisible = true
      }
    },
    loadSysRole() {
      loadSysRole(response => {
        this.menuList = response
      })
    },
    queryCreditLimit() {
      if (this.login) {
        this.getPcNetTerm()
        this.checkIsUseNt()
      }
    },

    showMenu() {
      clearTimeout(this.showMenuTimer)
      this.showMeau = true
      this.queryCreditLimit()
    },
    hideMenu() {
      this.showMenuTimer = setTimeout(() => {
        this.showMeau = false
        this.queryCreditLimit()
      }, 200)
    },
    // TODO haoyuanw  add start 2021-11-12 增加brand
    changeColor($event) {
      $event.currentTarget.className = 'brand-row-active'
    },
    resetColor($event) {
      $event.currentTarget.className = 'brand-row'
    },
    /**
     * 点击下面边框就去查看品牌页
     */
    gotoBrand(item) {
      this.brandList = []
      this.valueData.value = item.brandName
      this.$router.push({path: '/brand' + item.seoUrl})
    },
    // haoyuanw add 增加模糊查询品牌的接口(该接口不需要登录后再请求)
    queryBrand(value) {
      if (value === '') {
        this.brandList = []
        return
      }
      const brandRequestBody = {
        brandName: value
      }
      postAction('/tsCollectionBrand/like-list', brandRequestBody).then(response => {
        if (response.success) {
          this.brandList = response.result
        } else {
          this.$message.warning(response.message)
        }
      })
    },
    // TODO haoyuanw  add start 2021-11-12 增加brand
    // haoyuanw add 2021-1109 net term 新增查询接口
    getPcNetTerm() {
      if (this.login) {
        getAction('/slope/prod/pc-net').then(response => {
          if (response.success) {
            if (response.result === null) {
              return
            }
            this.pcPayMenthod = response.result
          // this.pcStatus = this.pcPayMenthod.pcNetQualificationStatus
          } else {
            this.$message.warning(response.message)
          }
        }).catch(err => {
          this.$message.warning(err)
        })
      }
    },
    handleClose() {
      this.changeURLStatic('signin', '')
      this.changeURLStatic('signup', '')
      this.loginVisible = false

      // 关闭登录弹框 去掉缓存信息
      localStorage.removeItem('url')
      localStorage.removeItem('spu')
      localStorage.removeItem('sku_id')
      localStorage.removeItem('selectData')
      localStorage.removeItem('currentPage')
      localStorage.removeItem('sku_num')
      //  1.7.0 售后单缺货新增，如果当前路由是售后单详情或者订单详情，那么就重定向到首页
      if (this.$route.name === 'whosalesDetails' || this.$route.name === 'refundAudit' || this.$route.name === 'shipperRefund') {
        this.$router.push({path: '/'})
      }
    },
    changeURLStatic(name, value) {
      var url = location.href
      var reg = eval('/([?|&]' + name + '=)[^&]*/gi')
      value = value.toString().replace(/(^\s*)|(\s*$)/g, '') // 移除首尾空格
      if (!value) {
        var url2 = url.replace(reg, '') // 正则替换
      } else {
        if (url.match(reg)) {
          var url2 = url.replace(reg, '$1' + value) // 正则替换
        } else {
          var url2 =
            url + (url.indexOf('?') > -1 ? '&' : '?') + name + '=' + value // 没有参数添加参数
        }
      }
      history.replaceState(null, null, url2) // 替换地址栏
    },
    gotoShoppingCart() {
      // 跳转到购物车
      // console.log(new Date());
      let date = new Date()
      let time = date.getTime()
      this.$router.push({path: `/shoppingCart?key=${time}`})
    },
    // 请求请求获取购物车数量
    getShoppingCartValue() {
      if (this.login) {
        getAction('/order/cart/list-count').then((response) => {
          if (response.success) {
            this.shoppingCartValue = response.result
          } else {
            this.$message.warning('Account and exited，please login again！')
          }
        })
      }
    },
    // 请求优惠券的数量
    getCouponCount() {
      if (this.login) {
        getAction('/ts/coupon/user/count').then((response) => {
          if (response.success) {
            this.myCouponCount = response.result
          } else {
            this.$message.warning('Account and exited，please login again！')
          }
        })
      }
    },
    getCreditLimit() {
      getCreditLimit('/balance/creditLimit').then(res => {
        console.log(res, '余额信息')
        if (res.code === 200) {
          this.limit = res.result
          console.log(this.limit, '限制信息')
          this.isError = false
        }
      }).catch(res => {
        console.log(res)
        this.isError = true
      })
    },

    wapShowMeau() {
      let nowPath = this.$route.name
      console.log(this.$route.name, this.$route)
      mixpanel.track('c_menuicon', {
        'page_form': nowPath
      })
      this.$emit('wapShow')
    },
    getEnvUrl(type) {
      let href = window.location.href
      let url = window.location.host
      if (href.indexOf('test') >= 0) {
        url =
          type === 'feCartWork'
            ? 'https://test-thalesmart-manage-ui2.hupofintech.com'
            : 'https://test-thalesmart-manage-ui.hupofintech.com'
        return url
      }
      if (href.indexOf('localhost') >= 0) {
        url =
          type === 'feCartWork'
            ? 'http://localhost:8080'
            : 'http://localhost:3000'
        return url
      }
      if (href.indexOf('pre') >= 0) {
        url =
          type === 'feCartWork'
            ? 'https://pre.shopvidi.com'
            : 'https://p.shopvidi.com'
        return url
      }
      if (href.indexOf('shopvidi') >= 0) {
        url =
          type === 'feCartWork'
            ? 'https://shopvidi.com'
            : 'https://p.shopvidi.com'
        return url
      }
      if (href.indexOf('192') >= 0) {
        url =
          type === 'feCartWork'
            ? 'http://192.168.3.54:8080'
            : 'http://192.168.3.54:3000'
        return url
      }
    },
    signOut() {
      const token = this.$ls.get('token')

      // add by cpgu 关闭ws 2023/03/07 begin
      try {
        closeWebsocket()
      } catch (e) {

      }
      // end by cpgu

      // 登出操作，
      // 1、调用登出接口 2、删除token
      if (token !== undefined && token !== null) {
        Vue.prototype.login = false
        // this.$ls.removeItem('token')
        localStorage.removeItem('pro__token')
        // haoyuanw add 2021-10-15 将localstorgae的 清除
        localStorage.removeItem('checkoutPath')
        this.$ls.remove('userInfo')
        // 返回到官网
        window.location.href = window.location.origin
        Logout('/sys/logout', token).then(response => {
          if (response.success) {
          } else {
            this.$message.warning(response.message)
          }
        })
      }
    },
    /**
     * 跳转申请信用支付的页面
     */
    gotoApplyNow() {
      console.log('gotoApplyNow')
    },
    gotoPlatform(item) {
      console.log(item, '这里的')
      // 判断是否有子菜单
      if (item.childrenList.length > 0) {
        // 如果有子菜单则获取第一个子菜单
        const firstChildren = item.childrenList[0]
        if (firstChildren.type === 'in') {
          // 如果内部跳转直接跳
          this.$router.push({name: firstChildren.path, params: {key: firstChildren.key}})
        } else if (firstChildren.type === 'platform') {
          // 如果跳转平台则
          window.location.href = this.feNetWork + this.$tokenUrl(firstChildren.path, firstChildren.status)
        }
      } else {
        switch (item.type) {
          case 'platform':
            window.location.href = this.feNetWork + this.$tokenUrl(item.path, item.status)
            break
          case 'out':
            window.location.href = item.path
            break
          case 'in':
            let path = '/' + item.path
            path = item.key ? (path + '/' + item.key) : path
            this.$router.push({path: path})
          case 'frame':
            this.$router.push({path: item.path})
            break
        }
      }
    },
    loadMenu() {
      getAction('/sys/permission/getPermissionByUser').then(response => {
        if (response.success) {
          this.meauList = response.result
          localStorage.setItem('meauList', JSON.stringify(response.result))
        } else {
          this.$message.warning(response.message)
        }
      })
    },
    showLoginHandle() {
      // SEM 判断当前用户是否存在，如果存在则显示login，否则显示register
      let hostId = localStorage.getItem('mac')
      if (hostId) {
        getAction('/customer/v0.2/hosts/' + hostId).then(response => {
          if (response.success) {
            if (response.result && response.result.length > 0) {
              this.loginType = 'login'
            } else {
              this.loginType = 'register'
            }
          } else {
            this.$message.warning(response.message)
          }
        })
      } else {
        this.loginType = 'register'
      }

      this.loginVisible = true
    },
    showInginPop(type) {
      this.loginType = 'register'
      this.loginVisible = true
    },
    loginHandle(type) {
      // 打开弹框记录当前url
      // localStorage.setItem('url', window.location.href)
      const utmSource = this.$cookie.get('utm_source')
      const utmMedium = this.$cookie.get('utm_medium')
      const utmCampaign = this.$cookie.get('utm_campaign')
      const utmId = this.$cookie.get('utm_id')
      const utmTerm = this.$cookie.get('utm_term')
      const utmContent = this.$cookie.get('utm_content')
      this.loginType = type
      this.loginVisible = true
      // TODO haoyuanw add 2021-09-15 GA
      if (type === 'register') {
        // eslint-disable-next-line no-undef
        this.changeURLStatic('signup', 1)
        mixpanel.track('v_signup_popup', {'page_from': window.location.href})
        gtag('event', 'click', {
          event_category: 'sign_up'
        })
      }
      if (type === 'login') {
        // this.changeURLStatic('signin', 1)
        mixpanel.track('v_login_popup', {'page_from': window.location.href})
      }

      /* 跳转到后台
        let url = this.getEnvUrl()
        if (type == 'register') {
          window.location.href = url + '/user/register?pageRedirect=' + href + '&utm_source=' + utmSource + '&utm_medium=' + utmMedium + '&utm_campaign=' + utmCampaign + '&utm_id=' + utmId + '&utm_term=' + utmTerm + '&utm_content=' + utmContent
        } else {
          window.location.href = url + '/user/login?pageRedirect=' + href + '&utm_source=' + utmSource + '&utm_medium=' + utmMedium + '&utm_campaign=' + utmCampaign + '&utm_id=' + utmId + '&utm_term=' + utmTerm + '&utm_content=' + utmContent
        } */
    },
    submitHandle(data, type) {
      this.changeURLStatic('signin', '')
      this.changeURLStatic('signup', '')
      this.loginVisible = false
      window.location.reload()
      // window.location.href = window.location.href
    },
    blurHandle() {
      this.focus = false
      console.log(this.focus)
    },
    focusHandle() {
      this.focus = true
      if (this.valueData.value !== '') {
        this.queryBrand(this.valueData.value)
      }
      console.log(this.focus)
    },
    // 回车搜索
    enterSearch() {
      document.onkeydown = e => {
        // 兼容FF和IE和Opera
        var event = e || window.event
        var key = event.which || event.keyCode || event.charCode
        if (key === 13 && !this.loginVisible && this.valueData.value !== '') {
          this.onSubmit()
        }
      }
    },
    addItems() {
      this.$router.push({
        path: '/credit-payment'
      })
    },
    onSubmit() {
      if (this.valueData.value !== '') {
        this.$router.push({
          name: 'search',
          params: {
            value: this.valueData.value
          }
        })
        this.brandList = []
        buryingPoint('5', '', this.valueData.value, this.$route.name)
      }

      // console.log(this.focus)
      // if (this.$route.name == 'search') {
      //   this.$emit('getList', this.valueData.value)
      // } else {

      // }
    }
  },
  watch: {
    isFirstOrder: {
      handler: function(n, o) {
        this.isFirstOrder = n
      },
      deep: true,
      immediate: true
    },
    isShowNt: {
      handler: function(n, o) {
        this.isShowNt = n
      },
      deep: true,
      immediate: true
    }

  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.brand-vilocal{
  background: #F3E93D;
  border-radius: 3px;
  opacity: 1;
  margin-left: 20px;
  width: 60px;
  height: 20px;
  font-size: 12px;
  font-family: Satoshi-Medium;
  line-height: 20px;
}
/deep/ .el-tag{
  padding: 0px;
}
/deep/ .el-tag.el-tag--danger{
  width: 70px;
  height: 20px;
  background: #FFEBE5;
  border-color: #FFEBE5;
  border-radius: 3px;
  font-size: 12px;
  font-family: Satoshi-Medium;
  font-weight: 500;
  line-height: 20px;
  color: #FB541C;
  text-align: center;
}

/deep/ .el-badge__content.is-fixed {
    top: 5px!important;
    right: 10px!important;
}
.money_box{
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 15px;
}
.line_between{
  width: 1px;
  height: 24px;
  background: #E1E1E1;
  margin: 0 5px;
}
.money_box_right{
  // border-left: solid 1px red;
}
.info-desc{
font-size: 12px;
font-family: Graphik;
font-weight: 400;
color: #262B2F;
}
.wapmeau {
  display: none;
  margin-left: -5px;
}
.meau {
  position: absolute;
  right: -5%;
  top: 60px;
  width: calc(50vw - 400px);
  max-width: 280px;
  min-width: 180px;
  height: auto;

  z-index: 9;
  font-size: 14px;
  font-family: Satoshi;
  font-weight: 400;
  text-align: left;
  color: #262b2f;

  transition: all 0.5;

  overflow: hidden;
  .meau-body {
    width: 100%;
    height: auto;
    box-sizing: border-box;
    border: 1px solid #e1e1e1;
    background-color: #fff;
  }

  p {
    cursor: pointer;
  }
  .el-collapse {
    border: 1px solid #ebeef5;
  }
  .meau-down {
    border-top: 1px solid #ebeef5;
    width: 100%;
    box-sizing: border-box;
    padding: 10px 16px;
    cursor: pointer;
  }
  .apply-border{
    .type{
      text-align: center;
      width: 36%;
      line-height: 30px;
      height: 30px;
      font-size: 12px;
      background: #262B2F;
      color: #FFFFFF;
      cursor: pointer;
    }
    .info{
      width: 100%;
      padding: 10px 16px;
      background: #F9F9F9;
      .info-name{
        display: flex;
        align-items: center;
        justify-content: flex-start;
        font-size: 12px;
        .status{
          background: #E1E1E1;
          border: 1px solid #E1E1E1;
          border-radius: 2px;
          padding: 4px 8px;
          margin-left: 4px;
        }
        .color-green{
          color: #41B76A;
        }
        .color-red{
          color: #F77073;
        }
        .color-gray{
          color: #8F8F8F;
        }
        .color-blue{
          color: #0B8CF4;
        }
        .color-brown{
          color: #C3824B;
        }
        .color-orange{
          color: #FF4812;
        }
      }
      .money{
        width: 100%;
        font-size: 18px;
        font-weight: 500;
        color: #262B2F;
        display: flex;
        justify-content: space-between;

      }
    }
    border-top: 1px solid #ebeef5;
    display: flex;
    align-items: center;
  }

  .meau-list {
    box-sizing: border-box;
    padding: 10px 16px;

    border-top: 1px solid #ebeef5;
    width: 100%;
    p {
      line-height: 30px;
    }
  }
  .meau-top {
    box-sizing: border-box;
    padding: 16px;
    border-top: 1px solid #ebeef5;
    width: 100%;
    p {
      text-decoration: underline;
    }
    span {
      cursor: pointer;
      display: block;
      margin: 10px 0;
      height: 30px;
      line-height: 30px;
      text-align: center;
      color: #fff;
      background: #FF4812;
    }
  }

  .shoping_button{
    margin-left: 30px;
    cursor: pointer;
    width: 109px;
    border: 1px solid #F6F5F3;
    border-radius: 17px;
    height: 30px;
    background: #fff;
    font-size: 12px;
    text-align: center;
    line-height: 30px;
    padding: 0 5px;
  }
}

.head {
  position: relative;
  width: 90%;
  height: 43px;
  padding-top: 15px;
  align-items: center;
  margin: 0 auto;
  text-align: center;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;

  .cart {
    // font-size: 31px;
    // color: #888;
    // margin-top: 3px;
    margin-right:5px;
    display: flex;
    justify-content: flex-start;
  }
  .item {
    // -webkit-transform: scale(0.8);
    // transform: scale(0.8);
    margin-left:15px;
  }

  .logo {
    width: 174px;
    height: 43px;
  }
  .search-box {

    width: 50%;
    display: flex;
    align-items: center;
  }
  .brand-main{
    height: 300px;
    overflow :auto;
    width: calc(50% - 100px);
    position: absolute;
    top:60px;
    left:50%;
    transform:translate(-53%);
    z-index: 999;
    background: #FFFFFF;
    box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.1);
    opacity: 1;
  }
  .brand-row{
    display: flex;
    align-items: center;
    margin:20px 0;
    margin-left:20px;
    background: white;
    cursor: pointer;
  }
  .brand-row-active{
    display: flex;
    align-items: center;
    margin:20px 0;
    margin-left:20px;
    background: rgba(234, 234, 234, 0.5);
    cursor: pointer;
  }
  // .brands-img{
  //   display: flex;
  //   align-items: center;
  //   justify-content: center;
  //   height: 50px;
  //   width: 50px;
  //   background: #FFFFFF;
  //   border: 1px solid #E1E1E1;
  //   border-radius: 50%;
  //   opacity: 1;
  // }
  .brand-name{
    font-size: 14px;
    font-family: Graphik;
    font-weight: 800;
    line-height: 16px;
    color: #262B2F;
    opacity: 1;
    margin-left:20px;
  }
  .brands-title{
    font-size: 14px;
    font-family: Graphik;
    font-weight: 500;
    line-height: 20px;
    color: #5D5D5D;
    opacity: 1;
    text-align: left;
    margin:20px 30px
  }
  .search-btn {
    background-color: #262613;
    border-color: #262613;
    width: 100px;
    border-radius: 0;
  }

.my-icon{
  margin-right:-20px;
}

.shopping-cart{
  display: flex !important;
  justify-content: center;
  //width:110px;
  max-width: 150px;
  border: 1px solid #262613;
  opacity: 1;
  border-radius: 18px;
  flex-direction: row-reverse;
  margin-left:-20px;
  margin-bottom:-4px;
}
.right-content-reg{
  background: #262623 !important;
}

.shopping-cart-info{
  margin-left:2px;
  margin-right: 13px;
  justify-content: center;
  display: flex;
  align-items: center;
}

.shopping-cart-info-mobile{
  display: none;

}
  .login-btns {
    position: relative;
    top:5px;
    //left:120px;
    // width: 150px;
    height: 43px;
    display: flex;
    align-items: center;
    flex-direction: row-reverse;
    justify-content: flex-start;
    span {
      cursor: pointer;
    }

  }
  .visitor{
    left:0px;
    top:0;

  }

  .visitor .my{
    left: -20px;
    top: 24px;
  }
  .right-content-login,
  .right-content-reg,
  .content1-right-personimg {
    font-size: 14px;
    height: 25px;
    line-height: 25px;
    display: inline-block;
  }
  .content_vidirect{
    position: absolute;
    cursor: pointer;
    top: 46% !important;
  }
  .content1-right-personimg {
    position:absolute;
    top: 50%;
    height: 25px;
    padding: 5px 0 1px 0;
    cursor: pointer;
    transform: translate3d(0, -50%, 0);
    -webkit-transform: translate3d(0, -50%, 0);
  }

  .content1-right-personimg-user{
    height: 25px;
    padding: 3px 0 3px 0;
    cursor: pointer;
    transform: translate3d(0, -50%, 0);
    -webkit-transform: translate3d(0, -50%, 0);
    margin-top: 20px;
    margin-left: 32px;
  }
  .content1-right-coupon{
    left: 20px ;
    .count_num{
      position: absolute;
      top: -5px;
      right: -10px;
      width: 16px;
      height: 16px;
      background: #F56C6C;
      border-radius: 50%;
      font-size: 12px;
      color: #fff;
      transform: scale(0.90);
      line-height: 16px;
    }
  }
  .right-content-reg {
    text-align: center;
    margin-left: 10px;
    width: 84px;
    background: #FF4812;
    border-radius: 3px;
  }
}
.show {
  display: none !important;
}
.search-icon {
  display: none;
}
.net-term{
  p{
    margin: 5px 0px;
    &:nth-child(1){
      text-decoration: underline;
      text-underline-offset: 5px;
      font-family: Satoshi-Bold;
      cursor:pointer;
    }
  }
}
@media screen and (min-width: 600px){
  .content_vidirect{
    left: -150px !important;
  }
}
@media screen and (max-width: 600px) {

  .head .visitor{

  }

  .search-icon-visitor{
    position: absolute;

  }
  .item{
    margin-left: 10px !important;
  }
  .login-btns{
    width:225px !important;
    left:0 !important;
    //margin-right: -5px;
  }
  .shopping-cart{
    left: 120px;
    margin-bottom:0 !important;
  }
  .shopping-cart-info-mobile{
    display: flex !important;
    margin-right:10px;
    justify-content: center;
  display: flex;
  align-items: center;
  }

  .content1-right-personimg-user{
    margin-left: 22px !important;
  }

  .head{
    height: 53px !important;
    .brand-main{
      width:105%;
      left:55%;
      // padding:0 auto;
      top:93px;
      // transform: translate(-58%);
    }
  }
  .content1-right-coupon{
    left: 0;
    right: -90px;
    .count_num{

       top:-2px !important;
  }
  }

  .content1-right-personimg{
    top:40% !important;
  }
  .content_vidirect{
    // left: -155px !important;
    display: none !important;
  }
  .right-content-reg,
  .right-content-login {
    display: none !important;
  }
  .right-content-reg.show {
    margin-left: 30px !important;
    width: 110px !important;
  }
  .show {
    display: block !important;
  }
  .hide {
    display: none !important;
  }

  .wapmeau {
    display: block;
    position: relative;
    z-index: 9;
    width: 20px;
  }
  .search-icon {
    display: block;
    font-size: 20px;
    z-index: 9;
    margin-bottom: -4px;
  }
  .head {
    padding-top: 0;
    .logo {
      position: absolute;
      left: 30px;
      transform-origin: 0 50%;
      transform: scale(0.6);
    }
    .search-box {
      display: none;
    }
  }
  .isSearch {
    padding-bottom: 50px;
    .search-box {
      display: flex;
      position: absolute;
      left: -10px;
      bottom: 10px;
      width: 95vw;
      top: 50px;
    }
  }
  .wap {
    max-width: 95%;
    margin: 5% auto;
    height: 80vh;
    .el-dialog {
      margin-top: 0 !important;
      width: 100vw !important;
    }
  }
}
@media screen and (max-width: 400px){
  .wap {
    height: 85vh;
  }
}
@media screen and (max-width: 380px){
  .wap {
    height: 85vh;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/components/head.vue